import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "react-hot-toast";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  // ⏳ Cooldown timer state
  const [cooldown, setCooldown] = useState(0);

  // Countdown effect
  useEffect(() => {
    let timer;
    if (cooldown > 0) {
      timer = setInterval(() => {
        setCooldown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [cooldown]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (cooldown > 0) {
      toast.error(`Please wait ${cooldown}s before sending again.`);
      return;
    }

    if (!email.trim()) {
      toast.error("Please enter your email address.");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(`${API_BASE}/api/auth/forgot-password`, {
        email,
      });
      toast.success(res.data.message || "Password reset link sent!");
      setCooldown(30); // Start 30s cooldown
    } catch (err) {
      console.error("Forgot password error:", err);
      toast.error(err.response?.data?.error || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-between bg-gradient-to-br from-blue-100 via-yellow-100 to-blue-200 dark:from-gray-900 dark:via-gray-800 dark:to-gray-700 transition-colors duration-700">
      {/* Centered form container */}
      <div className="flex-grow flex items-center justify-center px-4 py-10">
        <div className="bg-white/80 dark:bg-gray-900/80 backdrop-blur-md shadow-2xl rounded-2xl p-8 w-full max-w-md text-gray-900 dark:text-gray-100 transition-colors duration-700">
          <h2 className="text-center text-3xl font-extrabold mb-4 text-blue-900 dark:text-yellow-400">
            Forgot Password
          </h2>

          <p className="text-center text-sm mb-6 text-gray-700 dark:text-gray-300">
            Enter your registered email to receive a password reset link.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="w-full p-3 border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-400 dark:focus:ring-yellow-400 transition-all duration-200"
            />

            <button
              type="submit"
              disabled={loading || cooldown > 0}
              className="w-full bg-blue-900 hover:bg-blue-800 dark:bg-yellow-400 dark:hover:bg-yellow-300 text-white dark:text-gray-900 py-3 rounded-lg font-semibold transition duration-200 disabled:opacity-50"
            >
              {loading
                ? "Sending..."
                : cooldown > 0
                ? `Resend available in ${cooldown}s`
                : "Send Reset Link"}
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link
              to="/login"
              className="text-blue-700 dark:text-yellow-400 hover:underline font-medium"
            >
              ← Back to Login
            </Link>
          </div>
        </div>
      </div>

      {/* Footer fixed to bottom */}
      <footer className="text-center py-4 text-xs text-gray-600 dark:text-gray-400 border-t border-gray-200 dark:border-gray-800">
        © 2025 UPSC Journey. All rights reserved.
      </footer>
    </div>
  );
}
